import type { AssetType } from "../../Configurations/AssetTypeConfiguration/AssetTypeConfiguration.js";
import type { VerdiIdHints } from "../../utils/shortCodes/verdiIdGeneration.js";
import { createDelayedRegistrationHook } from "../utils/delayedRegistrationHook.js";

/**
 * Mints a unique verdiId for the given asset type. Registered in the backend
 * (where AssetIdentityModel lives) because verdi-common cannot import backend code.
 */
export const verdiIdGeneration =
    createDelayedRegistrationHook<(assetType: AssetType, hints?: VerdiIdHints) => Promise<string>>("verdiIdGeneration");
